var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('h1',[_vm._v(_vm._s(_vm.$t("WELCOME")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }